/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./_build/scripts/components/theme-section-loader.js":
/*!***********************************************************!*\
  !*** ./_build/scripts/components/theme-section-loader.js ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   addThemeLoadEvent: () => (/* binding */ addThemeLoadEvent),
/* harmony export */   delayedLoadSection: () => (/* binding */ delayedLoadSection),
/* harmony export */   loadSection: () => (/* binding */ loadSection)
/* harmony export */ });
//
// Theme Section Loader for Herd themes
//
function loadSection(name, events) {
  console.log('loadsection function for ', name);
  if (!Shopify.theme.sections || !Shopify.theme.sections.register) {
    delayedLoadSection(name, events);
    return;
  }
  const sectionInstances = Shopify.theme.sections.getInstances(name);
  if (sectionInstances.length === 0) {
    Shopify.theme.sections.register(name, events);
  }
  Shopify.theme.sections.load(name);
}

function delayedLoadSection(name, events) {
  var sectionTemplate = { name, events };
  console.log('push section template to theme.liquid var for later loading: ', sectionTemplate);
  theme.sections.push(sectionTemplate);
}

function addThemeLoadEvent() {
  window.addEventListener('load', () => {
    console.log('Theme: Load event fired with sections: ', theme.sections);

    theme.sections.forEach((sectionTemplate) => {
      const sectionInstances = Shopify.theme.sections.getInstances(sectionTemplate.name);
      if (Shopify.theme.sections && sectionInstances.length === 0) {
        Shopify.theme.sections.register(sectionTemplate.name, sectionTemplate.events);
      }
      Shopify.theme.sections.load(sectionTemplate.name);
    });
  });
}




/***/ }),

/***/ "./_build/scripts/theme/helpers.js":
/*!*****************************************!*\
  !*** ./_build/scripts/theme/helpers.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   debounce: () => (/* binding */ debounce),
/* harmony export */   getCookie: () => (/* binding */ getCookie),
/* harmony export */   lockScrolling: () => (/* binding */ lockScrolling),
/* harmony export */   setCookie: () => (/* binding */ setCookie),
/* harmony export */   unlockScrolling: () => (/* binding */ unlockScrolling),
/* harmony export */   updateCanonicalLinks: () => (/* binding */ updateCanonicalLinks)
/* harmony export */ });
// Lock Scrolling

var siteContainerEl = document.querySelector('[data-site-container]');

function lockScrolling() {
  siteContainerEl.style.overflowY = 'hidden';
}

// Unlock Scrolling
function unlockScrolling() {
  siteContainerEl.style.removeProperty('overflow');
}

function setCookie(name, value, days) {
  let expires = '';

  if (days && days !== '') {
    let date = new Date;
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toUTCString();
  } else {
    expires = '; expires=""';
  }

  document.cookie = `${name}=${value}${expires}; path=/`;
}

function getCookie(name) {
  let nameEquals = name + '=';
  let ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(nameEquals) != -1) return c.substring(nameEquals.length, c.length);
  }

  return null;
}


function updateCanonicalLinks(fullUrl) {
  const url = fullUrl.includes('&')
    ? fullUrl.split('&')[0]
    : fullUrl;

  const jsonLdScript = document.querySelector('[type="application/ld+json"]');
  const oldJson = jsonLdScript.innerHTML;
  let [preLinkJson, postLinkJson] = oldJson.split('"@id": "');
  postLinkJson = postLinkJson.split(postLinkJson.split('"')[0])[1];
  console.log(`${preLinkJson}"@id": "${url}${postLinkJson}`);
  jsonLdScript.innerHTML = `${preLinkJson}"@id": "${url}${postLinkJson}`;

  const canonicalLink = document.querySelector('[rel="canonical"]');

  canonicalLink.href = theme.url + url;
}

const debounce = (fn, delay) => {
  let timeOutId;
  return function (...args) {
    if (timeOutId) {
      clearTimeout(timeOutId);
    }
    timeOutId = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {
/*!*******************************************!*\
  !*** ./_build/scripts/sections/header.js ***!
  \*******************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_theme_section_loader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../components/theme-section-loader */ "./_build/scripts/components/theme-section-loader.js");
/* harmony import */ var _theme_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../theme/helpers */ "./_build/scripts/theme/helpers.js");



const selectors = {
  section: '[data-section-header]',
  navOpen: '[data-nav-open]',
  navClose: '[data-nav-close]',
  nav: '[data-nav-wrapper]',
  headerOverlay: '[data-overlay-main]',
  navTier1: '[data-nav-tier-1-menu]',
  navTier2: '[data-nav-tier-2-menu]',
  navTier3: '[data-nav-tier-3-menu]',
  navTier2Wrapper: '[data-nav-tier-2-wrapper]',
  navTier3Wrapper: '[data-nav-tier-3-wrapper]',
  backTier1: '[data-back-tier-1]',
  sectionWrapper: '[data-main-content]'
};

const classes = {
  visible: 'is-visible',
  active: 'is-active',
  search: 'is-search'
};

const sectionEvents = {
  onLoad() {
    this.initiateOverflowingNav();
    window.addEventListener('resize', () => {
      this.initiateOverflowingNav();
    });
    window.addEventListener('orientationchange', () => {
      this.initiateOverflowingNav();
    });

    theme.SearchDrawer.init();
    theme.Search.init();
    
    this.initNavigation();
    this.addBreakpointEventListeners();
    console.log('Section "Header": Loaded!', this);
  },

  onUnload() {
    delete this.elements;

    console.log('Section "Header": Unloaded!', this);
  },

  initiateOverflowingNav() {
    const header = document.querySelector(selectors.section);
    const sectionWrapper = document.querySelector(selectors.sectionWrapper);

    sectionWrapper.style.setProperty('margin-top', (header.clientHeight - 1) + 'px');
  },

  addBreakpointEventListeners() {
    window.addEventListener('breakpoint-down:lg', this.initNavigation.bind(this));
    window.addEventListener('breakpoint-up:lg', this.initNavigation.bind(this));
  },

  initNavigation() {
    console.log('init navigation');
    const section = document.querySelector(selectors.section);
    const mql = window.matchMedia(`(min-width: ${window.theme.breakpoints.lg}px)`);
    const tier1Menu = section.querySelector(selectors.navTier1);

    if (!mql.matches) {
      this.initMenuOpenClose(section);

      const backTier1 = section.querySelector(selectors.backTier1);

      Array.from(tier1Menu.children).forEach((tier1Li) => {
        const link = tier1Li.firstElementChild;

        if (link.classList && link.classList.contains('has-children')) {
          const tier2Wrapper = tier1Li.querySelector(selectors.navTier2Wrapper);
          const tier2Menu = tier1Li.querySelector(selectors.navTier2);

          link.addEventListener("click", (e) => {
            e.preventDefault();

            tier2Wrapper.classList.add(classes.visible);
            backTier1.classList.add(classes.visible);
          });

          if (tier2Menu) {
            Array.from(tier2Menu.children).forEach((tier2Li) => {
              const tier2link = tier2Li.firstElementChild;
  
              if (tier2link.classList && tier2link.classList.contains('has-children')) {
                const tier3Wrapper = tier2Li.querySelector(selectors.navTier3Wrapper);
  
                tier2link.addEventListener("click", (e) => {
                  e.preventDefault();
  
                  tier3Wrapper.classList.add(classes.visible);
                  backTier1.querySelector('.back-text').textContent = tier2Wrapper.dataset.tierTwoBackText;
                });
              }
            });
          }
        }
      });

      backTier1.addEventListener("click", () => {
        const tier2menus = section.querySelectorAll('.tier-2-wrapper.is-visible');
        const tier3menus = section.querySelectorAll('.tier-3-wrapper.is-visible');

        if (tier3menus.length) {
          tier3menus.forEach((menu) => {
            menu.classList.remove(classes.visible);
            backTier1.querySelector('.back-text').textContent = tier1Menu.dataset.tierOneBackText;
          });
        } else {
          tier2menus.forEach((menu) => {
            menu.classList.remove(classes.visible);
            backTier1.classList.remove(classes.visible);
          });
        }
      });
    } else {
      const subMenuItems = tier1Menu.querySelectorAll('.has-grandchildren');

      subMenuItems.forEach((subMenuItem) => {
        const tier2Menu = subMenuItem.querySelector(selectors.navTier2);

        Array.from(tier2Menu.children).forEach((tier2Li) => {
          const tier2link = tier2Li.firstElementChild;

          if (tier2link.classList && tier2link.classList.contains('has-children')) {
            const tier3Wrapper = tier2Li.querySelector(selectors.navTier3Wrapper);

            tier2link.onmouseover = () => {
              const tier3menus = section.querySelectorAll('.tier-3-wrapper.is-visible');

              tier3menus.forEach((menu) => {
                menu.classList.remove(classes.visible);
              });

              tier3Wrapper.classList.add(classes.visible);
            };
          };
        });
      });
    }
  },

  initMenuOpenClose(section) {
    const openButton = section.querySelector(selectors.navOpen);
    const closeButton = section.querySelector(selectors.navClose);
    const navWrapper = section.querySelector(selectors.nav);
    const mobileOverlay = document.querySelector(selectors.headerOverlay);

    openButton.addEventListener("click", (e) => {
      navWrapper.classList.add(classes.visible);
      mobileOverlay.classList.add(classes.active);
      (0,_theme_helpers__WEBPACK_IMPORTED_MODULE_1__.lockScrolling)();
    });

    closeButton.addEventListener("click", (e) => {
      navWrapper.classList.remove(classes.visible);
      mobileOverlay.classList.remove(classes.active);
      (0,_theme_helpers__WEBPACK_IMPORTED_MODULE_1__.unlockScrolling)();
    });
  },
};

theme.SearchDrawer = (function() {
  const searchDrawerSelectors = {
    headerSection: '[data-header-section]',
    drawer: '[data-predictive-search-drawer]',
    drawerOpenButton: '[data-predictive-search-open-drawer]',
    headerSearchInput: '[data-predictive-search-drawer-input]',
    predictiveSearchWrapper: '[data-predictive-search-mount="drawer"]'
  };

  var drawerInstance;

  function init() {
    console.log('SLATE SEARCH RUNNING STILL');
    setAccessibilityProps();

    drawerInstance = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: function() {
        setHeight();
        lockBodyScroll();
      },
      onDrawerClose: function() {
        theme.SearchHeader.clearAndClose();
        var drawerOpenButton = document.querySelector(
          searchDrawerSelectors.drawerOpenButton
        );

        if (drawerOpenButton) drawerOpenButton.focus();

        unlockBodyScroll();
      },
      withPredictiveSearch: true,
      elementToFocusOnOpen: document.querySelector(searchDrawerSelectors.headerSearchInput)
    });
  }

  function setAccessibilityProps() {
    var drawerOpenButton = document.querySelector(searchDrawerSelectors.drawerOpenButton);

    if (drawerOpenButton) {
      drawerOpenButton.setAttribute('aria-controls', 'SearchDrawer');
      drawerOpenButton.setAttribute('aria-expanded', 'false');
      drawerOpenButton.setAttribute('aria-controls', 'dialog');
    }
  }

  function setHeight() {
    var searchDrawer = document.querySelector(searchDrawerSelectors.drawer);
    var headerHeight = document.querySelector(searchDrawerSelectors.headerSection)
      .offsetHeight;

    searchDrawer.style.height = '0px';
  }

  function close() {
    drawerInstance.close();
  }

  function lockBodyScroll() {
    theme.Helpers.enableScrollLock();
  }

  function unlockBodyScroll() {
    theme.Helpers.disableScrollLock();
  }

  return {
    init: init,
    close: close
  };
})();

function numberOfResultsTemplateFct(data) {
  if (data.products.length === 1) {
    return theme.strings.one_result_found;
  } else {
    return theme.strings.number_of_results_found.replace(
      '[results_count]',
      data.products.length
    );
  }
}

// (a11y) This function will be used by the Predictive Search Component
// to announce that it's loading results
function loadingResultsMessageTemplateFct() {
  return theme.strings.loading;
}

function validateSearchHandler(searchEl, submitEl) {
  submitEl.addEventListener(
    'click',
    validateSearchInput.bind(this, searchEl)
  );
}

function validateSearchInput(searchEl, evt) {
  var isInputValueEmpty = searchEl.value.trim().length === 0;
  if (!isInputValueEmpty) {
    return;
  }

  if (typeof evt !== 'undefined') {
    evt.preventDefault();
  }

  searchEl.focus();
}

theme.SearchHeader = (function() {
  const searchHeaderselectors = {
    searchInput: '[data-predictive-search-drawer-input]',
    searchResults: '[data-predictive-search-mount="drawer"]',
    searchFormContainer: '[data-search-form-container]',
    searchSubmit: '[data-search-form-submit]'
  };

  var componentInstance;

  function init(config) {
    var searchInput = document.querySelector(searchHeaderselectors.searchInput);
    var searchSubmit = document.querySelector(searchHeaderselectors.searchSubmit);
    var searchUrl = searchInput.dataset.baseUrl;

    componentInstance = new window.Shopify.theme.PredictiveSearchComponent({
      selectors: {
        input: searchHeaderselectors.searchInput,
        result: searchHeaderselectors.searchResults
      },
      searchUrl: searchUrl,
      resultTemplateFct: window.theme.SearchResultsTemplate,
      numberOfResultsTemplateFct: numberOfResultsTemplateFct,
      numberOfResults: config.numberOfResults,
      loadingResultsMessageTemplateFct: loadingResultsMessageTemplateFct,
      onInputBlur: function() {
        return false;
      },
      onOpen: function(nodes) {
        var searchInputBoundingRect = searchInput.getBoundingClientRect();

        // For tablet screens and up, stop the scroll area from extending past
        // the bottom of the screen because we're locking the body scroll
        var maxHeight =
          window.innerHeight -
          searchInputBoundingRect.bottom -
          (config.isTabletAndUp ? 20 : 0);

        nodes.result.style.maxHeight = maxHeight + 'px';
      },
      onClose: function(nodes) {
        nodes.result.style.maxHeight = '';
      },
      onBeforeDestroy: function(nodes) {
        // If the viewport width changes from mobile to tablet
        // reset the top position of the results
        nodes.result.style.top = '';
      }
    });

    validateSearchHandler(searchInput, searchSubmit);
  }

  function unload() {
    if (!componentInstance) {
      return;
    }

    componentInstance.destroy();
    componentInstance = null;
  }

  function clearAndClose() {
    if (!componentInstance) {
      return;
    }

    componentInstance.clearAndClose();
  }

  return {
    init: init,
    unload: unload,
    clearAndClose: clearAndClose
  };
})();

theme.Search = (function() {
  var classes = {
    searchTemplate: 'template-search'
  };
  const searchSelectors = {
    siteHeader: '[data-section-header]'
  };
  var mediaQueryList = {
    mobile: window.matchMedia('(max-width: 749px)'),
    tabletAndUp: window.matchMedia('(min-width: 750px)')
  };

  function init() {
    if (!document.querySelector(searchSelectors.siteHeader)) {
      return;
    }

    Object.keys(mediaQueryList).forEach(function(device) {
      mediaQueryList[device].addListener(initSearchAccordingToViewport);
    });

    initSearchAccordingToViewport();
  }

  function initSearchAccordingToViewport() {
    theme.SearchDrawer.close();
    theme.SearchHeader.unload();
    theme.SearchPage.unload();

    if (mediaQueryList.mobile.matches) {
      theme.SearchHeader.init({
        numberOfResults: 4,
        isTabletAndUp: false
      });

      if (isSearchPage()) {
        theme.SearchPage.init({ isTabletAndUp: false });
      }
    } else {
      // Tablet and up
      theme.SearchHeader.init({
        numberOfResults: 4,
        isTabletAndUp: true
      });

      if (isSearchPage()) {
        theme.SearchPage.init({ isTabletAndUp: true });
      }
    }
  }

  function isSearchPage() {
    return document.body.classList.contains(classes.searchTemplate);
  }

  function unload() {
    theme.SearchHeader.unload();
    theme.SearchPage.unload();
  }

  return {
    init: init,
    unload: unload
  };
})();

(0,_components_theme_section_loader__WEBPACK_IMPORTED_MODULE_0__.loadSection)('section-header-section', sectionEvents);
})();

/******/ })()
;